export class Message {
  subject: string;
  description: string;
}

export class Pagination {
  total: number;
  pages: number;
  pageCount: number;
}

export class PaginatedMessages {
  pagination: Pagination;
  messages: Message[];
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/models/message.ts